/**
 * 拍卖详情
 * @module store/modules/actions
 * @description 拍卖详情 Vuex Store Module
 *
 * **/
import {
  getActionInfo,
  recordViewCount,
  getQueryActionInfo,
} from "@/api/actions";
import { isToken } from "@/api/user.js";
const state = {
  auctionDetail: {},
  globalMessage: null, // 全局提示用
  bidding: 0, // 拍卖状态
  updataDays: null, // 倒计时多少天
  updataTimer: [], // 倒计时时间
  isOneHour: false, // 是否是一小时内开始
};

const mutations = {
  SET_AUCTION_DETAIL(state, detail) {
    state.auctionDetail = detail;
  },
  SET_GLOBAL_MESSAGE(state, payload) {
    state.globalMessage = payload;
  },
  SET_IS_ONE_HOUR(state, val) {
    state.isOneHour = val;
  },
  SET_BIDDING(state, val) {
    state.bidding = val;
  },
  SET_UPDATA_DAY_TIMER(state, val) {
    state.updataDays = val;
  },
  SET_UPDATA_TIMER(state, val) {
    state.updataTimer = val;
  },
};

const actions = {
  // 拍卖倒计时-天
  fetchUpdataDaysTimer({ commit }, value) {
    try {
      commit("SET_UPDATA_DAY_TIMER", value);
    } catch (error) {
      console.error("Failed to fetch auction detail:", error);
    }
  },
  // 拍卖倒计时
  fetchUpdataTimer({ commit }, value) {
    try {
      commit("SET_UPDATA_TIMER", value);
    } catch (error) {
      console.error("Failed to fetch auction detail:", error);
    }
  },
  // 拍卖状态
  fetchBinding({ commit }, value) {
    try {
      commit("SET_BIDDING", value);
    } catch (error) {
      console.error("Failed to fetch auction detail:", error);
    }
  },
  // 是否倒计时1小时
  fetchIsOneHour({ commit }, value) {
    try {
      commit("SET_IS_ONE_HOUR", value);
    } catch (error) {
      console.error("Failed to fetch auction detail:", error);
    }
  },
  // 强提醒消息
  fetchGlobalMessage({ commit }, value) {
    try {
      commit("SET_GLOBAL_MESSAGE", value);
    } catch (error) {
      console.error("Failed to fetch auction detail:", error);
    }
  },
  // 获取拍卖详情
  async fetchAuctionDetail({ commit }) {
    try {
      const response = await getActionInfo();
      console.log("Auction Detail Response:", response);
      commit("SET_AUCTION_DETAIL", response.data);
    } catch (error) {
      console.error("Failed to fetch auction detail:", error);
    }
  },
  // 获取拍卖详情-传参接口
  async fetchQueryAuctionDetail({ commit }, value) {
    try {
      const response = await getQueryActionInfo({ auctionId: value });
      console.log("Auction Detail Response:", response);
      commit("SET_AUCTION_DETAIL", response.data);
    } catch (error) {
      console.error("Failed to fetch auction detail:", error);
    }
  },
  // 判断是否登录-请求后端接口判断是否登录
  async checkLogin() {
    try {
      const response = await isToken();
      console.log("登录状态Login Status Response:", response);
      if (response.code === 0) {
        // 用户已登录，执行相应操作
        console.log("用户已登录User is logged in");
        return true;
      } else {
        if (response.code == -2001) {
          // token过期处理
          console.log("用户登录过期Token has expired");
          return false;
        } else {
          // 其他错误处理
          console.error("登录错误Error:", response.message);
        }
      }
    } catch (error) {
      console.error("Failed to check login status:", error);
    }
  },
  // 请求后端接口-记录观看次数
  async recordView({ state }) {
    try {
      if (state.auctionDetail.id) {
        const response = await recordViewCount({
          auctionId: state.auctionDetail.id,
        });
        console.log("Record View Response:", response);
        if (response.code === 0) {
          console.log("观看次数已记录View count recorded");
        } else {
          console.error("记录观看次数错误Error:", response.message);
        }
      } else {
        console.warn("拍卖ID不存在Auction ID does not exist");
      }
    } catch (error) {
      console.error("Failed to record view count:", error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
